import { isPlatformBrowser } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
} from "@angular/core";
import { ParamFilters } from "@app/models/filtermodels/ParamFilters";
import { Partner } from "@app/models/partner/IPartner";
import { HotelFiltersService } from "@app/services/hotelfilters.service";
import { Subject, takeUntil } from "rxjs";
@Component({
    selector: "clever-transfer",
    templateUrl: "./transfer.component.html",
    styleUrls: ["./transfer.component.scss"],
    standalone: false,
})
export class TransferHotelComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    @Input() mode: string;
    @Input() partner: Partner;
    @Input() inclusiveListExt: any[];
    inclusiveList: any[];
    fromtraffics: boolean = false;
    isBrowser: boolean = false;
    mittransfer: boolean = false;
    ohnetransfer: boolean = false;
    mietwagen: boolean = false;
    zugtumflug: boolean = false;
    selectedList: string[] = [];

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            if (this.inclusiveListExt?.length > 0) {
                this.fromtraffics = true;
                const tmp = [];
                for (let i = 0; i < this.inclusiveListExt.length; i++) {
                    if (
                        this.inclusiveListExt[i].code === "MT" ||
                        this.inclusiveListExt[i].code === "OT" ||
                        this.inclusiveListExt[i].code === "MW" ||
                        this.inclusiveListExt[i].code === "ZG"
                    ) {
                        tmp.push(this.inclusiveListExt[i]);
                    }
                }
                this.inclusiveList = this.sortArray(tmp);
            }
            this.initFilterSub();
        }
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    checkList(): void {
        for (let i = 0; i < this.inclusiveList?.length; i++) {
            if (this.inclusiveList[i].code) {
            }
        }
    }

    selectmittransfer() {
        this.mittransfer = !this.mittransfer;
        this.hotelService.transferlist("MT", this.mittransfer, true);
    }

    selectohnetransfer() {
        this.ohnetransfer = !this.ohnetransfer;
        this.hotelService.transferlist("OT", this.ohnetransfer, true);
    }

    selectmietwagen() {
        this.mietwagen = !this.mietwagen;
        this.hotelService.transferlist("MW", this.mietwagen, true);
    }

    selectzugtumflug() {
        this.zugtumflug = !this.zugtumflug;
        this.hotelService.transferlist("ZG", this.zugtumflug, true);
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op) >= 0) {
            push = false;
        }
        this.hotelService.transferlist(op, push, true);
        this.cdr.markForCheck();
    }

    initFilterSub(): void {
        this.hotelService.getfilters$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((filter: ParamFilters) => {
                this.mittransfer = false;
                this.mietwagen = false;
                this.ohnetransfer = false;
                this.zugtumflug = false;
                this.selectedList = [];
                for (let i = 0; i < filter?.transferlist?.length; i++) {
                    if (filter.transferlist[i] === "MT") {
                        this.mittransfer = true;
                        this.selectedList.push("MT");
                    }
                    if (filter.provider !== "peakwork") {
                        if (filter.transferlist[i] === "OT") {
                            this.ohnetransfer = true;
                            this.selectedList.push("OT");
                        }
                        if (filter.transferlist[i] === "MW") {
                            this.mietwagen = true;
                            this.selectedList.push("MW");
                        }
                        if (filter.transferlist[i] === "ZG") {
                            this.zugtumflug = true;
                            this.selectedList.push("ZG");
                        }
                    }
                }
                this.cdr.markForCheck();
            });
    }
}

/*
{
            code: 'MT',
            name: 'mit Transfer',
            checked: false
        },
        {
            code: 'OT',
            name: 'ohne Transfer',
            checked: false
        },
        {
            code: 'MW',
            name: 'Mietwagen',
            checked: false
        },
        {
            code: 'ZG',
            name: 'Zug zum Flug',
            name1: '(innerhalb Deutschland)',
            checked: false
        }
*/
